export default __webpack_public_path__ + "static/media/csm_app-store-badge_6f74703f88.526ecaa1.png";